import axios from 'axios';
import jsonp from 'jsonp';
import $router from '../router';
import { $elm } from '../plugins/element';

axios.interceptors.response.use(
  (response) => {
    if (response.headers['set-token']) {
      localStorage.setItem('token', response.headers['set-token']);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.request.use((config) => {
  if (localStorage.getItem('token')) {
    config.headers.common['token'] = localStorage.getItem('token');
  }
  return config;
});

let baseURL = '/api/yunying';
// let uploadBaseURL = "/api";
let url = '/api/yunying'; // form下载地址
let vestBaseURL = '/api/vest';
switch (process.env.NODE_ENV) {
  case 'dev':
    // uploadBaseURL = "api";
    baseURL = '/api/yunying';
    break;
  case 'uat':
    // uploadBaseURL = "api"; //
    baseURL = '/api/yunying';
    break;
  //   case "production":
  //     uploadBaseURL = "/api";
  //     // baseURL = '/api/yunying';
  //     break;
  default:
    break;
}

export const downloadUrl = url;

class Api {
  get(link, describe, params) {
    return axios.get(baseURL + link, { params }).then((res) => {
      return this.printFunc(link, res, describe);
    });
  }

  post(link, describe, data = {}, other = {}) {
    return axios.post(baseURL + link, data, other).then((res) => {
      return this.printFunc(link, res, describe);
    });
  }

  upload(link, describe, params) {
    return axios
      .post(baseURL + link, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        return this.printFunc(link, res, describe);
      });
  }

  armourGet(link, describe, params) {
    return axios.get(vestBaseURL + link, { params }).then((res) => {
      return this.printFunc(link, res, describe);
    });
  }
  armourPost(link, describe, data = {}, other = {}) {
    return axios.post(vestBaseURL + link, data, other).then((res) => {
      return this.printFunc(link, res, describe);
    });
  }

  map_get(link, describe, params) {
    params.key = ''; //高德地图 key
    return new Promise((resolve, reject) => {
      jsonp(
        `https://restapi.amap.com${link}?key=${params.key}&location=${params.location}`,
        {},
        (err, data) => {
          if (!err) {
            resolve(data);
          } else {
            reject(err);
          }
        },
      );
    });
  }

  ipCity_get(params) {
    params.key = ''; //高德地图 key
    return new Promise((resolve, reject) => {
      jsonp(`https://restapi.amap.com/v3/ip?key=${params.key}&ip=${params.ip}`, {}, (err, data) => {
        if (!err) {
          resolve(data);
        } else {
          reject(err);
        }
      });
    });
  }

  printFunc(link, res, describe) {
    let data = res.data;
    /* eslint-disable */
    if (process.env.NODE_ENV !== 'production') {
      if (res.config.url !== '/api/yunying/osmMessages/countUnread') {
        console.log(`${describe}:${link} ===>>`);
        console.log(data);
      }
    }
    const code = data.code;
    if (code) {
      switch (code) {
        // 登录凭证无效
        case 10002:
          $elm.$alert(data.msg, '提示', {
            confirmButtonText: '确定',
            showClose: false,
            callback: () => {
              $router.replace('/login');
              localStorage.clear();
              location.reload();
            },
          });
          break;
        case 10016:
          return data;
        default:
          $elm.$message.error(data.msg);
      }
      return Promise.reject(data.msg);
    }
    return data;
  }
}

export default new Api();
